import {
    cleanCommonParams,
    mapAttachmentsParams,
    mapTagsParams,
    mapContentParams,
    mapFeedItemParams,
    mapImageParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
} from './common';

const mapProductUpdateParams = (isCreate, data) => {
    // Handle undefined or null data
    if (!data || typeof data !== 'object') {
        return new Promise((resolve) => {
            resolve({
                product_update: {
                    // Return minimal required fields for update
                    id: data?.id || null,
                },
            });
        });
    }

    const {
        attachments,
        tags,
        categories,
        content,
        feed_item,
        image,
        platforms,
        products,
        sales_channels,
        search_phrase_ids,
        states,
        expired_at,
        ...params
    } = data;

    return new Promise((resolve) => {
        try {
            const result = {
                product_update: {
                    ...cleanCommonParams(params),
                    ...mapAttachmentsParams(isCreate, attachments),
                    ...mapTagsParams(isCreate, tags),
                    ...mapContentParams(isCreate, content),
                    ...mapFeedItemParams(isCreate, feed_item),
                    ...mapImageParams(isCreate, image),
                    ...mapPlatformsParams(isCreate, platforms),
                    ...mapProductsParams(isCreate, products),
                    ...mapSalesChannelsParams(isCreate, sales_channels),
                    ...mapStatesParams(isCreate, states),
                    category_ids: categories,
                    search_phrase_ids: search_phrase_ids || [],
                },
            };
            resolve(result);
        } catch (_error) {
            resolve({
                product_update: {
                    ...cleanCommonParams(params),
                },
            });
        }
    });
};

export { mapProductUpdateParams };
